import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import { Watch } from 'scrollmonitor-react';
import Happy from 'react-icons/lib/io/android-happy';
import map from 'lodash/map';
import sampleSize from 'lodash/sampleSize';
import shuffle from 'lodash/shuffle';
import slice from 'lodash/slice';
import Mailto from 'react-mailto';

import Animated from '../components/Animated';
import {
  center,
  textContainer,
  wrapper,
  fullWidth,
  halfWidth,
  thirdWidth,
  shadowless,
} from '../styles';
import BigList from '../components/BigList';
import Image from '../components/Image';
import { Link } from 'react-router-dom';

const getImage = (folder, filename, r) => {
  return [
    {
      srcSet: require(`../assets/${folder}/${filename}-thumb-${r}.jpg`),
      media: '(max-width: 100px)',
    },
    {
      srcSet: require(`../assets/${folder}/${filename}-sm-${r}.jpg`),
      media: '(max-width: 720px)',
    },
    {
      srcSet: require(`../assets/${folder}/${filename}-${r}.jpg`),
    },
  ];
};

const getImageSequence = (folder, filename, start, end) => {
  let imgs = [];
  for (let i = start; i <= end; i++) {
    // note: we add a key prop here to allow react to uniquely identify each
    // element in this array. see: https://reactjs.org/docs/lists-and-keys.html
    imgs.push(getImage(folder, filename, i));
  }
  return imgs;
};

const row1 = (image, index) => {
  return (
    <div {...fullWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

const row2 = (image, index) => {
  return (
    <div {...halfWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

const row3 = (image, index) => {
  return (
    <div {...thirdWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

const unreleasedImages = getImageSequence(
  'unreleased',
  'unreleased-generative-art-by-lucastswick',
  1,
  28,
);

class Adobe extends Component {
  constructor(props) {
    super(props);
    this.state = { set1: [] };
  }

  componentWillMount() {
    this.props.loadTheme();
  }

  getBlomHeader = (index) => {
    return [
      {
        srcSet: require(`../assets/blom/blom-a-generative-art-series-by-lucastswick-thumb-${index}.jpg`),
        media: '(max-width: 100px)',
      },
      {
        srcSet: require(`../assets/blom/blom-a-generative-art-series-by-lucastswick-sm-${index}.jpg`),
        media: '(max-width: 720px)',
      },
      {
        srcSet: require(`../assets/blom/blom-a-generative-art-series-by-lucastswick-${index}.jpg`),
      },
    ];
  };

  componentWillReceiveProps(nextProps) {
    const blomHeader = this.getBlomHeader(1);
    // const galleryHeader = getImage('laika', 'gallery', 1);

    const headerImage = getImage(
      'community-gardens',
      'community-gardens-header',
      1,
    );

    let set1 = slice(unreleasedImages, 0, 4);
    set1 = sampleSize(shuffle(set1), 3);
    set1.push(unreleasedImages[5]);

    let set2 = slice(unreleasedImages, 6, 10);
    set2 = sampleSize(shuffle(set2), 2);

    let set3 = slice(unreleasedImages, 11, 15);
    set3 = sampleSize(shuffle(set3), 3);

    let set4 = slice(unreleasedImages, 16, 21);
    set4 = sampleSize(shuffle(set4), 2);

    this.setState({
      set1,
      set2,
      set3,
      set4,
      headerImage,
      items: {
        nfts: {
          title: 'Generative art is creativity, automated',
          uid: 'nfts',
          slug: 'nfts',
          // link: 'https://foundation.app/collection/solastalgia?sort=newest',
          excerpt:
            'The very first minted on-chain artwork in my generative series Blóm.',
          // cta: 'See it on Foundation',
          // colorTheme: { base: '#121212', hilite: '#df0000' },
          headerImage: blomHeader,
          images: [blomHeader],
        },
        // frahm: {
        //   title: 'However…',
        //   uid: 'however',
        //   slug: 'however',
        //   link: 'https://gallery.frahm.art/',
        //   excerpt:
        //     'It turns out being an artist can be tumultuous! In an effort to create more financial stability, I co-founded an art-adjacent startup that makes generative frames for digital art, and we received pre-seed funding. I have been enjoying the engineering challenges of building a Web3 product from scratch that leverages blender, react-three-fiber, 3D animation, and AR/VR.',
        //   cta: 'Explore our Gallery',
        //   // colorTheme: { base: '#121212', hilite: '#df0000' },
        //   headerImage: galleryHeader,
        //   images: [galleryHeader],
        // },
      },
    });
  }

  render() {
    const { items, headerImage, set1, set2, set3, set4 } = this.state;
    const { theme } = this.props;

    return (
      <Fragment>
        <Image ratio="16x9" sources={headerImage} />

        <div {...textContainer}>
          <Helmet title="Adobe + Lucas" description="💕" />
          <Animated as="h1">Hello!</Animated>
          <Animated>
            I'm Lucas, Senior Software Engineer and Creative Coder.
          </Animated>
          <Animated>
            I&apos;ve been using technology in my creative pursuits since I was
            a teenager, drawing album covers in Photoshop for my band and
            writing tools to generate visuals for our live shows. I found a home
            writing html/js/css for the browser, knowing I could make tools and
            sites, games and art that anyone can access. I've been building
            things on the web ever since.
          </Animated>
          <Animated>
            Recently, I rode the NFT wave and created unique vanilla javascript{' '}
            <Link to="/work/blom-a-generative-art-series">generative art</Link>.
            I then co-founded an art-adjacent startup that makes{' '}
            <a
              href="https://fdk.frahm.art/editor"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              generative frames for digital art
            </a>
            . I have been enjoying the engineering challenges of building a web
            application from scratch that leverages React, Blender, React Three
            Fiber, 3D animation, shaders, and a custom component library. It
            exports dynamic .usdz files for viewing in AR/VR. Neat.
          </Animated>
        </div>

        <BigList items={items} theme={theme} showExcerptOnSm={true} />

        <div {...textContainer}>
          <Animated as="h2">Previously</Animated>
          <Animated>
            I was a <strong>Technical Director at Nike</strong>, where I managed
            the front-end team of a startup in an Incubator program. We shipped
            a subscription service for kids shoes, and built multiple internal
            tools for the CS and fulfillment teams, including a data-driven
            generative art installation that displayed sales data in a mythic
            forest. We wrote our own component library from scratch. I also
            played the role of Senior Engineer, and enjoy the challenge of
            balancing the needs of the business with the needs of the team. I'm
            proud of the work we accomplished.
          </Animated>
          <Animated>
            Before that, I worked with different design agencies, and delivered{' '}
            <Link to="/work/generative-art-installation-in-union-square">
              installations
            </Link>{' '}
            that ran on 20 foot tall digital displays in Union Square, NY while
            shipping CMS driven websites like{' '}
            <a
              href="https://rideicon.com/gear"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Icon Motosports
            </a>
            .
          </Animated>
          <Animated>
            While my day job was full of exciting challenges, I kept pushing my
            creative skills with different projects including{' '}
            <Link to="/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu">
              data-driven art installations
            </Link>
            , C++ generative art projects, and{' '}
            <a
              href="https://vimeo.com/user733911"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              song-writing and music-video making
            </a>
            .
          </Animated>

          <Animated as="h2">Why am I a good fit for Adobe?</Animated>
          <Animated>
            I LOVE building tools, and I cannot express what a joy it would be
            to create tools that help people be more creative. I firmly believe
            the world is a better place with more art in it, and if I can help
            people be more expressive, welp, that's a win in my book.
          </Animated>
          <Animated>
            I'll show up with an incredible amount of enthusiasm and positivity
            to apply the skills I've learned over the years to help Adobe
            continue to be the leader in creative software. I'm a team player,
            and I'm excited to work with a group of like-minded folx who are
            passionate about the intersection of creativity and technology.
          </Animated>

          <Animated as="h2">Why is Adobe a good fit for me?</Animated>
          <Animated>
            To be honest, I've been a fan of Adobe since I was a kid. I remember
            the first time I used Photoshop. I saved up for a wacom tablet and
            drew for hours and hours. Seeing the products evolve over the years
            and expand into new areas (why hello there Lightroom) has been
            inspiring. I want to be a part of that. I want to help shape the
            future of creative software and push the boundaries of what is
            possible. I want to be a part of Adobe.
          </Animated>
        </div>

        <video width="100%" height="auto" autoPlay loop muted={true}>
          <source src="/vid/header-full.mp4" type="video/mp4" />
          <Image ratio="16x9" sources={headerImage} theme={theme} />
        </video>

        <div {...textContainer}>
          <Animated as="h2">Employment</Animated>
          <Animated>
            <strong>2024</strong> My team and I are building an AI-powered
            nostalgia-induced VRM (a standard for 3D characters that can be used
            across games and experiences) collection, based on a sci-fi universe
            created by an artist. We are delivering thousands of generated 3D
            models, where each one has a unique personality and experience that
            users can interact with. Currently in stealth mode.
            <br />
            <strong>2022</strong> Co-founded{' '}
            <a
              href="https://fdk.frahm.art/editor"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Frahm
            </a>
            , generative frames for your digital art
            <br />
            <strong>2021</strong> Sold some NFTs (remember those?) over{' '}
            <a
              href="https://opensea.io/collection/blom-by-lucastswick"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              multiple
            </a>{' '}
            <a
              href="https://opensea.io/collection/lucastswick-form-decay"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              generative art
            </a>{' '}
            <a
              href="https://foundation.app/collection/solastalgia"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              collections
            </a>
            <br />
            <strong>2018-2021</strong> Nike, Technical Director
            <br />
            <strong>2018</strong>{' '}
            <a
              href="/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Community Gardens
            </a>
            , a data-driven generative art installation at NCSU. Was awarded an
            artist residency
            <br />
            <strong>2015-2018</strong>{' '}
            <a
              href="https://weareparliament.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Parliament
            </a>
            , Technical Director. Worked with brands like Capital One, Icon
            Motorsports, Prometheus, and more, while building internal tools for
            the agency.
            <br />
            <strong>2017</strong>{' '}
            <a
              href="/work/lightblades-installation-at-the-geode-in-portland"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Lightblades
            </a>
            , a 3-story tall generative art public art installation at the
            Geode, Portland OR
            <br />
            <strong>Previous</strong> Various agencies; Software Engineer, Flash
            developer, delivering work for Nike, LucasArts, Lego, and more.
          </Animated>

          <Animated as="h2">Competencies</Animated>
          <Animated as="ul">
            <li>
              Strong engineering skills and over 10 years creating front-end
              experiences
            </li>
            <li>
              Delivers high-performance, reliable, well-documented, and
              maintainable code.
            </li>
            <li>High tolerance for ambiguity</li>
            <li>
              Super-lover of teamwork; also very capable of participating in all
              aspects of development lifecycle, from concepting through
              development to maintenance
            </li>
            <li>
              A long history of successfully saying Let&apos;s try it! to new
              challenges
            </li>
            <li>Effective communicator</li>
            <li>Patient debugger</li>
            <li>Creative problem solver</li>
            <li>
              Nimble minded when moving along gradient from high level strategy
              to local details
            </li>
            <li>Measured optimist</li>
            <li>Bringer of good vibes to any opportunity</li>
          </Animated>

          <Animated as="h2">Skills</Animated>
          <Animated>
            During my career, I've often picked up new skills for specific
            projects. I taught myself enough C++ to generate thousands of
            high-resolution artworks that a browser couldn't handle, extended
            CraftCMS with custom plugins to deliver a job-application management
            system to handle the ridiculous amounts of emails that a job posting
            would create, maintained projects at Nike that were built by
            vendors, and am currently learning Python so I can script inside
            Blender and make my life easier. I'm eager to learn and a fast
            study.
          </Animated>
          <Animated as="ul">
            <li>Advanced proficiency with HTML, CSS, and JavaScript</li>
            <li>
              10+ years collaborating with clients directly while at creative
              agencies
            </li>
            <li>
              8+ years of being a Technical Director, responsible for defining
              project methodologies (agile, scrum) and dev ops
            </li>
            <li>
              Multiple large-scale installations created with THREE.js or
              processing
            </li>
            <li>
              Shipped my first React app in 2015 and never looked back. React
              was still in beta and the webapp (which uses threejs as well) is
              actually{' '}
              <a
                href="https://hsstudio.haydenshapes.com/hsstudio/?activeLocationUid=us&activeBoardUid=hypto-krypto"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                still live
              </a>
            </li>
            <li>
              3 years in the Web3 space, mostly shipping generative Web3D
              experiences
            </li>
            <li>Very eager to learn new programs</li>
          </Animated>

          <Animated as="h2">Values</Animated>
          <Animated as="ul">
            <li>Kindness first. Assume the best in people by default.</li>
            <li>Inclusive, non-judgemental environments</li>
            <li>Building community and relationships</li>
            <li>A clean code base</li>
            <li>Nimble, forward-thinking peers</li>
          </Animated>

          <Animated as="h2">Superpowers</Animated>
          <Animated as="ul">
            <li>
              <strong>Woodworker</strong> currently building bespoke furniture
              which Milly Cypress, my CNC machine that carves generative
              patterns into wood.
            </li>
            <li>
              <strong>Musician</strong> creating an audio-reactive experience
            </li>
            <li>
              Canadian with <strong>US Green Card</strong>
            </li>
            <li>
              Vegan, sober, but <strong>still fun</strong> (I think)
            </li>
          </Animated>

          <Animated as="h2">Some samples of my generative art</Animated>
          <Animated>
            These are generated in-browser with Javascript and THREE.js.
          </Animated>
        </div>

        <div {...wrapper}>
          {map(set1, (image, index) => {
            if (index < 3) {
              return row3(image, index);
            } else if (index % 3 === 0) {
              return row1(image, index);
            } else {
              return row3(image, index);
            }
          })}

          {map(set2, (image, index) => {
            if (index % 5 === 0) {
              const image2 = set2[index + 1];
              return (
                <Fragment key={`group-${index}`}>
                  {row2(image, index)}
                  {row2(image2, index + 1)}
                </Fragment>
              );
            } else if (index % 5 === 1) {
              return null;
            } else {
              return row3(image, index);
            }
          })}

          {map(set3, (image, index) => {
            return row3(image, index);
          })}

          {map(set4, (image, index) => {
            if (index === 0) {
              const image2 = set4[index + 1];
              return (
                <Fragment key={`group-${index}`}>
                  {row2(image, index)}
                  {row2(image2, index + 1)}
                </Fragment>
              );
            }
          })}
        </div>

        <div {...textContainer}>
          <Animated as="h2">What's next?</Animated>
          <Animated>
            I'd love to learn more about the Founding Engineer, Emerging Product
            Incubation role at Adobe. Honestly, you are doing cool work, and at
            the very least we should grab a coffee.
          </Animated>
          <Animated>
            Email me:{' '}
            <Mailto
              email="lucas@generativeartist.com"
              obfuscate={true}
              {...shadowless}
              target="_blank"
            >
              lucas@generativeartist.com
            </Mailto>
          </Animated>
          <div {...center}>
            <Animated as="div">
              <Happy color="#F772D7" size={90} />
            </Animated>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Watch(Adobe);



// WEBPACK FOOTER //
// ./src/pages/Adobe.js